import useToken from '@plug-core/hooks/useToken'
import { EarnVault } from '@plug-core/interfaces/earn'
import { formatMoney, formatNumber } from '@plug-core/utils/formatNumber'
import { titleize } from '@plug-core/utils/titleize'
import { Chip, ListRow, Text } from '@ui'
import React, { FC } from 'react'
import { Tag, TokenWithChain } from './shared'

interface Props {
  vault: EarnVault
  onClick: (vault: EarnVault) => void
}

export const VaultListItem: FC<Props> = ({ vault, onClick }) => {
  const primaryToken = vault.underlyingTokens[0]
  const tokenLogo = useToken({ address: primaryToken?.address }).logo
  const apy = vault.analytics.apy.total
  const tvlUsd = Number(vault.analytics.tvl.usd || 0)

  return (
    <ListRow
      onClick={() => onClick(vault)}
      leading={
        <TokenWithChain
          logo={tokenLogo}
          fallbackName={primaryToken?.symbol || vault.name}
          chainId={vault.chainId}
        />
      }
      primary={vault.name}
      secondary={
        <span className="mt-0.5 flex gap-1">
          <Tag>{titleize(vault.protocol.name)}</Tag>
        </span>
      }
      trailing={
        <span className="flex min-w-[86px] flex-col items-end gap-0.5">
          <Chip tone="success" className="tabular">
            {formatNumber(apy, '%', { maximumFractionDigits: 2 })}
          </Chip>
          <Text as="span" variant="caption" tone="fg-2" tabular>
            {formatMoney(tvlUsd)}
          </Text>
        </span>
      }
    />
  )
}
